import { Option } from '../../../../general-types';

type TransformToOptionsType<
  TList extends Record<string, any>,
  TValue extends keyof TList,
  TLabel extends keyof TList,
> = {
  list: TList[];
  valueKey: TValue;
  labelKey: TLabel;
};

export const transformToOptions = <
  TList extends Record<string, any>,
  TValue extends keyof TList,
  TLabel extends keyof TList,
>({
  list,
  valueKey,
  labelKey,
}: TransformToOptionsType<TList, TValue, TLabel>): Option<
  TList[TValue],
  TList[TLabel]
>[] =>
  list.map((item) => ({
    value: item[valueKey],
    label: item[labelKey],
  }));
